import React from 'react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/index.js';
import { stripPopperProps, withPopper } from '../../../shared/withPopper.js';
import { stripPortalProps, withPortal } from '../../../shared/withPortal.js';
import { menuStyle } from '../../base/Menu/styles/Menu.style.js';

import { IMenuConfiguration, IMenuProps,IMenuState } from './models/index.js';
import { MENU_CATEGORY_KEY, MENU_COMPONENT_KEY } from './Menu.meta.js';

export class Menu extends ComponentBase<IMenuProps, IMenuState, IMenuConfiguration> {
	categoryKey = MENU_CATEGORY_KEY;
	componentKey = MENU_COMPONENT_KEY;

	constructor(props: IMenuProps) {
		super(props);
	}

	render() {
		const componentProps = stripPortalProps(stripPopperProps(this.componentProps));
		const { children, type, ...props } = componentProps;
		const className = this.appendClassNames(type === 'mega' ? 'mega-menu' : undefined);
		return (
			<div {...props} role="menu" className={className} data-selector={this.selector}>
				{children}
			</div>
		);
	}
}

const MenuWithPopper = withPopper(Menu);

export const MenuWithPopperPortal = withPortal(MenuWithPopper);

export default InjectedStyledComponent(
	MenuWithPopperPortal,
	MENU_CATEGORY_KEY,
	MENU_COMPONENT_KEY,
	undefined,
	undefined,
	undefined,
	menuStyle,
);
